export default __webpack_public_path__ + "static/media/about-users.6ad79f55.svg";